module.exports = __webpack_public_path__ + "static/media/hojeng-android-qr-code.334113cc.svg";